import { apiRequest } from '../../api/client';

/**
 * Send custom verification email via SendGrid (no-reply@neatschedule.com).
 * Requires the session token in the Authorization header.
 * Throws on error; rate-limited (429) errors include retryAfterSeconds on the thrown error.
 */
export async function sendCustomVerificationEmail(idToken) {
  try {
    return await apiRequest('/api/auth/email-verification/send', {
      token: idToken,
      method: 'POST',
      body: {},
    });
  } catch (error) {
    const retry =
      error?.retryAfterSeconds ??
      error?.body?.retryAfterSeconds ??
      error?.body?.details?.retryAfterSeconds;
    if (error?.status === 429 && typeof retry === 'number') {
      error.retryAfterSeconds = retry;
    }
    throw error;
  }
}

/**
 * Verify email using custom token from link. Returns { success: true } or throws.
 */
export async function verifyEmailWithToken(token) {
  return apiRequest(`/api/auth/email-verification/verify?token=${encodeURIComponent(token)}`);
}
